import './styles.scss';
import React from 'react';  
import { Card } from '@fluentui/react-components';  

  export interface CardProps {  
  image: string;  
  title: string;  
  onClick: () => void;  
}  
const ActionCards: React.FC<{ cards: CardProps[] }> = ({ cards }) => {  
  return (  
    <div className="action-cards">
      {cards.map((card, index) => (
        <Card key={index} className="action-card" onClick={card.onClick}>
          <div className="action-card__icon">
            <img src={`/images/${card.image}.svg`} alt={card.title} />
          </div>
          <div className="action-card__title-container">
            <div className="action-card__title">{card.title}</div>
          </div>
        </Card>
      ))}
    </div>
  );  
};  
  
export default ActionCards;  